import { render, staticRenderFns } from "./MastercardAccountDisable.vue?vue&type=template&id=30b5bf6c&"
import script from "./MastercardAccountDisable.vue?vue&type=script&lang=js&"
export * from "./MastercardAccountDisable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports